export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Debnix'

// Set by Sidebar's sign-out handler before calling signOut(), read by
// ProtectedRoute once the resulting auth-state change redirects away —
// lets it send demo users somewhere other than the (unlinked) login page.
export const POST_LOGOUT_REDIRECT_KEY = 'debnix_post_logout_redirect'

export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ONBOARDING: '/onboarding',
  ONBOARDING_SYNC: '/onboarding/sync',
  DASHBOARD: '/dashboard',
  PRODUCTS: '/products',
  PREDICTIONS: '/predictions',
  SUPPLIERS: '/suppliers',
  EMAIL_DRAFTS: '/email-drafts',
  ALERTS: '/alerts',
  SETTINGS: '/settings',
  REPORTS: '/reports',
  ABC_ANALYSIS: '/abc-analysis',
  PURCHASE_ORDERS: '/purchase-orders',
  BLOG: '/blog',
  ABOUT: '/about',
  STOCKY_ALTERNATIVE: '/stocky-alternative',
}
export const RISK_LEVELS = {
  CRITICAL: 'critical',
  WARNING: 'warning',
  WATCH: 'watch',
  HEALTHY: 'healthy',
}
export const ALERT_TYPES = {
  CRITICAL_STOCK: 'critical_stock',
  REORDER_REMINDER: 'reorder_reminder',
  TREND_SPIKE: 'trend_spike',
  TREND_DROP: 'trend_drop',
  SYNC_COMPLETE: 'sync_complete',
  EMAIL_SENT: 'email_sent',
}
export const EMAIL_DRAFT_STATUS = {
  DRAFT: 'draft',
  APPROVED: 'approved',
  SENT: 'sent',
  DISMISSED: 'dismissed',
}
export const PO_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  CONFIRMED: 'confirmed',
  PARTIALLY_RECEIVED: 'partially_received',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
}
export const DEFAULT_ALERT_THRESHOLD_DAYS = 7
export const MIN_PASSWORD_LENGTH = 8
export const SIDEBAR_WIDTH = 240
export const SIDEBAR_COLLAPSED_WIDTH = 64
export const TOPBAR_HEIGHT = 56
export const CONTENT_MAX_WIDTH = 1100